// This file contains stimulation activities categorized by age range.
// In a real app, this can be expanded significantly.

export const stimulationActivities = [
    {
        ageRange: [0, 3], // 0-3 months
        title: "Stimulasi untuk Bayi 0-3 Bulan",
        activities: [
            { id: "s03_1", text: "Mengajak bayi tersenyum dan berbicara." },
            { id: "s03_2", text: "Menggantung benda berwarna cerah yang bergerak." },
            { id: "s03_3", text: "Memperdengarkan musik lembut kepada bayi." },
            { id: "s03_4", text: "Meraih dan memegang mainan." },
        ]
    },
    {
        ageRange: [4, 6], // 4-6 months
        title: "Stimulasi untuk Bayi 4-6 Bulan",
        activities: [
            { id: "s46_1", text: "Bermain 'Cilukba'." },
            { id: "s46_2", text: "Membantu bayi untuk tengkurap dan telentang." },
            { id: "s46_3", text: "Memperlihatkan cermin kepada bayi." },
            { id: "s46_4", text: "Mengajak bayi meraih benda sedikit lebih jauh." },
        ]
    },
    {
        ageRange: [7, 12], // 7-12 months
        title: "Stimulasi untuk Bayi 7-12 Bulan",
        activities: [
            { id: "s712_1", text: "Mengajarkan bayi duduk." },
            { id: "s712_2", text: "Mengajak memanggil 'mama' atau 'papa'." },
            { id: "s712_3", text: "Melatih bayi berdiri berpegangan." },
            { id: "s712_4", text: "Memberikan mainan yang bisa dipukul." },
        ]
    },
    {
        ageRange: [13, 24], // 13-24 months
        title: "Stimulasi untuk Anak 1-2 Tahun",
        activities: [
            { id: "s1324_1", text: "Melatih berjalan tanpa bantuan." },
            { id: "s1324_2", text: "Mengajak anak mencoret-coret dengan krayon." },
            { id: "s1324_3", text: "Menyusun menara dari 2-3 balok." },
            { id: "s1324_4", text: "Mengajarkan nama bagian tubuh." },
        ]
    }
];
